import { FlagIcon } from '@heroicons/react/24/outline'

export default function KinesisEventCalendarItem({
    kinesisEvent,
    timescale = 'block'
}) {

    const eventTypeLabel = kinesisEvent.eventType
        ?.split('-')
        .map(s => s.charAt(0).toUpperCase() + s.slice(1))
        .join(' ')

    const className = timescale === 'week'
        ? 'bg-white border-t-[3px] border-gray-300 w-full p-1 rounded-md shadow'
        : 'py-0.5 px-1 rounded-md border-l-[3px] 2xl:border-l-[4px] border-gray-400 bg-white shadow'

    return (
        <div className={className}>
            <div className='flex items-center gap-x-0.5'>
                <FlagIcon className='h-4 w-4 shrink-0 text-gray-400' />

                <div className='flex-1 truncate text-xxs 2xl:text-xs font-medium'>
                    {kinesisEvent.name}
                </div>
            </div>

            {eventTypeLabel && (
                <div className='pl-0.5 text-gray-500 text-xxs 2xl:text-xs'>
                    {eventTypeLabel}
                </div>
            )}
        </div>
    )
}
